import { PhoneNumber } from '../../../../../ui/gzPhoneInput/types';

export const FULL_NAME_MAX_LENGTH = 128;

export enum MdrContactDetailsFormEvents {
  CLEAR_DATA = 'mdrContactDetailsFormClearData',
  FORM_GROUP_CREATED = 'mdrContactDetailsFormGroupCreated',
}

export interface MdrContactDetailsFormViewData {
  value?: Partial<MdrContactDetailsFormValuePrivate>;
  enabled?: MdrContactDetailsFormEnabled;
  hasStackedFormFields?: boolean;
  hasSendButtonBelowEmail?: boolean;
  required?: boolean;
}

export interface MdrContactDetailsFormValuePublic {
  fullName: string;
  email: string;
  emailVerificationCode: string;
  phoneNumber: PhoneNumber;
}

export interface MdrContactDetailsFormValuePrivate extends MdrContactDetailsFormValuePublic {
  hasVerifiedEmailAddress: boolean;
}

export interface MdrContactDetailsImportConfig {
  hasVerifiedEmailAddress: boolean;
  fullName: string;
  email: string;
  phoneNumber?: PhoneNumber;
}

export interface MdrContactDetailsFormEnabled {
  fullName: boolean;
  email: boolean;
  sendEmailVerificationCode: boolean;
  emailVerificationCode: boolean;
  phoneNumber: boolean;
  clearData: boolean;
}
